import React, { useState } from "react";
import ForgotStepPhone from "./ForgotSteps/ForgotStepPhone";
import ForgotStepOtp from "./ForgotSteps/ForgotStepOtp";
import ForgotStepNewPassword from "./ForgotSteps/ForgotStepNewPassword";
import { useTranslation } from "../../../context/TranslationContext";

const ForgotForm = ({ onBackToLogin }) => {
  const { backToLogin, createNewPassword, forgotPassword } = useTranslation();
  const [step, setStep] = useState(1);
  const [data, setData] = useState({
    phoneNumber: "",
    token: "",
  });

  const handleStep1Next = (phoneNumber) => {
    setData({ ...data, phoneNumber });
    setStep(2);
  };

  const handleStep2Next = (token) => {
    setData({ ...data, token });
    setStep(3);
  };

  const handleComplete = () => {
    onBackToLogin();
  };

  return (
    <div className="w-full">
      <div className="flex items-center mb-6">
        <button
          onClick={onBackToLogin}
          className="text-product-type-color text-sm font-semibold flex items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          {backToLogin}
        </button>
      </div>

      <h3 className="font-bold text-xl mb-6 text-[#333738]">
        {step === 3 ? createNewPassword : forgotPassword}
      </h3>

      {step === 1 && <ForgotStepPhone onNext={handleStep1Next} />}
      {step === 2 && (
        <ForgotStepOtp
          phoneNumber={data.phoneNumber}
          onNext={handleStep2Next}
        />
      )}
      {step === 3 && (
        <ForgotStepNewPassword token={data.token} onComplete={handleComplete} />
      )}
    </div>
  );
};

export default ForgotForm;
